export default __webpack_public_path__ + "static/media/frberger.992d1fc8.jpeg";